import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useConsultantCianChat } from './hooks/useConsultantCianChat';
import {
  closeConsultantCianChat,
  openAutorisationMotivationConsultantCianChat,
} from '../../actions/consultantCianChat';
import { AutorisationMotivationPopup } from '../../components/AutorisationMotivationPopup';
import { ConsultantCianChatButton, ConsultantCianChatButtonContainer } from '../../components/ConsultantCianChatButton';
import { ConsultantCianChatPopup } from '../../components/ConsultantCianChatPopup';
import { isOpenSelector, isAutorisationPopupOpenSelector } from '../../selectors/consultantCianChat';
import { getUser } from '../../selectors/user';
import { useApplicationContext } from '../../utils/applicationContext';
import { ConsultantCianChatOnboarding } from '../ConsultantCianChatOnboarding';

export const ConsultantCianChat = () => {
  const dispatch = useDispatch();
  const { config } = useApplicationContext();
  const isEnabled = config.get('Newbuilding.CianKpnChat.Enabled') || false;
  const isOpened = useSelector(isOpenSelector);
  const isAutorisationPopupOpen = useSelector(isAutorisationPopupOpenSelector);
  const user = useSelector(getUser);
  const { openChat } = useConsultantCianChat();

  const onClick = React.useCallback(() => {
    if (!user.isAuthenticated) {
      dispatch(openAutorisationMotivationConsultantCianChat());
    } else {
      openChat();
    }
  }, [dispatch, openChat, user.isAuthenticated]);

  const onClose = React.useCallback(() => {
    dispatch(closeConsultantCianChat());
  }, [dispatch]);

  if (!isEnabled) {
    return null;
  }

  return (
    <>
      <ConsultantCianChatButtonContainer>
        <ConsultantCianChatOnboarding>
          <ConsultantCianChatButton onClick={onClick} />
        </ConsultantCianChatOnboarding>
      </ConsultantCianChatButtonContainer>

      <AutorisationMotivationPopup
        isAutorisationPopupOpened={isAutorisationPopupOpen}
        onClick={openChat}
        onClose={onClose}
      />
      {isOpened && <ConsultantCianChatPopup onClose={onClose} url="" />}
    </>
  );
};
